export default __webpack_public_path__ + "static/media/shadow.efa0f31d.gltf";